document.addEventListener('DOMContentLoaded', () => {
    const schadstoffplakettensuche = document.querySelector('.schadstoffplakette');
    if (schadstoffplakettensuche) {

//////////////////////////
// ZU ERGEBNIS SCROLLEN
/////////////////////////
        const result = document.querySelector('.result');
        if (result && result.childElementCount > 0) {
            result.scrollIntoView();
        }

////////////////////////
// LIGHTBOX FÜR HILFE
///////////////////////

// Elemente holen
        const lightbox = document.getElementById('lightbox');
        const lightboxImg = lightbox.querySelector('img');

// Klick auf Link: Bild laden und anzeigen
        document.querySelectorAll('.lightbox-link').forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const src = this.getAttribute('href');
                lightboxImg.src = src;
                lightbox.style.display = 'flex';
            });
        });

// Klick auf Hintergrund oder X zum Schließen
        lightbox.addEventListener('click', () => {
            lightbox.style.display = 'none';
            lightboxImg.src = '';
        });

/////////////////////////////
// LADEBALKEN FÜR FORMULARE
////////////////////////////
        const suchmaske = document.querySelector('.suchmaske');
        const form = suchmaske.querySelector('form');
        const loader = '/frontend_build/images/icons/ladebalken.gif';
        const img = document.createElement('img');

        form.addEventListener('submit', function () {
            img.src = loader;
            img.classList.add('loader');
            suchmaske.appendChild(img);
        });
    }
});